import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { QueryState } from "@/shared/ui/QueryState";
import { useRoleQuery, useUpdateRole } from "../api/queries";
import { RoleForm } from "../ui/RoleForm";

export function RoleEditPage() {
  const nav = useNavigate({ from: "/app/roles/$id/edit" });
  const { id } = useParams({ from: "/app/roles/$id/edit" });
  const { data, ...result } = useRoleQuery(id);
  const updateRole = useUpdateRole(id);

  const role = data;

  return (
    <>
      <Header />
      <Main>
        <div className="space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div>
              <h1 className="font-semibold text-2xl">ແກ້ໄຂບົດບາດ</h1>
              <p className="text-muted-foreground">
                ປັບປຸງລາຍລະອຽດແລະສິດທິຂອງບົດບາດ.
              </p>
            </div>

            <Button
              type="button"
              variant="outline"
              onClick={() => nav({ to: "/app/roles" })}
            >
              <ArrowLeftIcon className="mr-2 h-4 w-4" />
              ກັບຄືນ
            </Button>
          </div>

          <QueryState
            result={result}
            title="ກໍາລັງໂຫຼດບົດບາດ"
            description="ກໍາລັງດຶງລາຍລະອຽດ"
            variant="fullscreen"
          >
            {!role ? null : (
              <div className="rounded-xl border bg-card p-6">
                <RoleForm
                  initialValues={{
                    name: role.name,
                    description: role.description,
                    permissions: role.permissions,
                  }}
                  onSubmit={async (vals) => {
                    await updateRole.mutateAsync(vals);
                    nav({ to: "/app/roles" });
                  }}
                  submitting={updateRole.isPending}
                />
              </div>
            )}
          </QueryState>
        </div>
      </Main>
    </>
  );
}
